<div class="ui basic segment" style="margin: -8px -25px;" lmsPadding paddingT="5px" paddingX="10">
    <div class="ui secondary sub pointing menu">
      <div 
        class="ui item"
        [routerLink]="['./allowed-countries']"
        routerLinkActive="active"
      >
      Allowed Countries
      </div>
      <div
       class="ui item" [routerLink]="['./disallowed-countries']" routerLinkActive="active">
      Disallowed Countries    
      </div>
    </div>
    <div class="ui basic segment w-100">
      <router-outlet></router-outlet>
    </div>
  </div>
